import { inject, Injectable, signal } from '@angular/core';
import { OpenConfirmationModalService } from '@vendasta/galaxy/confirmation-modal';
import { MaybeAsync } from '@angular/router';
import { map } from 'rxjs';

@Injectable()
export class UnsavedChangesGuard {
  private readonly confirmationModal = inject(OpenConfirmationModalService);
  private readonly hasUnsavedChanges = signal(false);

  canDeactivate(): MaybeAsync<boolean> {
    if (this.hasUnsavedChanges()) {
      return this.confirmationModal
        .openModal({
          type: 'warn',
          title: 'AI_ASSISTANT.SHARED.UNSAVED_CHANGES.TITLE',
          message: 'AI_ASSISTANT.SHARED.UNSAVED_CHANGES.MESSAGE',
          confirmButtonText: 'AI_ASSISTANT.SHARED.UNSAVED_CHANGES.CONFIRM',
        })
        .pipe(map((confirmation) => !!confirmation));
    }
    return true;
  }

  notifyStateChanged(hasChanges: boolean): void {
    this.hasUnsavedChanges.set(hasChanges);
  }
}
